import React from 'react';

interface FullScreenButtonProps {
  isFullScreen: boolean;
  setIsFullScreen: (value: boolean) => void;
  position?: 'absolute' | 'relative';
  style?: React.CSSProperties;
}

const FullScreenButton: React.FC<FullScreenButtonProps> = ({ 
  isFullScreen, 
  setIsFullScreen, 
  position = 'absolute',
  style = {}
}) => {
  const defaultStyle: React.CSSProperties = {
    position,
    top: position === 'absolute' ? 0 : undefined,
    right: position === 'absolute' ? 1 : undefined,
    zIndex: 10,
    background: '#fff',
    color: '#222',
    border: '1px solid #d1d5db',
    borderRadius: 4,
    padding: '0 16px',
    fontWeight: 500,
    fontSize: '14px',
    height: 36,
    boxSizing: 'border-box',
    cursor: 'pointer',
    boxShadow: 'none',
    outline: 'none',
    transition: 'background 0.2s',
    margin: 0,
    ...style
  };

  return (
    <button
      onClick={() => setIsFullScreen(!isFullScreen)}
      style={defaultStyle}
      onMouseOver={e => e.currentTarget.style.background = '#f3f4f6'}
      onMouseOut={e => e.currentTarget.style.background = '#fff'}
    >
      {isFullScreen ? '전체화면 해제' : '전체화면'}
    </button>
  );
};

export default FullScreenButton; 